export default __webpack_public_path__ + "static/media/CoastOfArdashir.f276bbcc.jpg";